import { DatePicker, Radio } from 'antd';
import { MDBInput, MDBFile } from 'mdb-react-ui-kit';
import React from 'react';
import moment from 'moment';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const CarKyc = ({ formData, setFormData }) => {
  const handleRadioChange = (e) => {
    const { value } = e.target;
    setFormData(prev => ({
      ...prev,
      PersonType: value,
      policyHolderType: value,
    }));
  };

  const handleDateChange = (date, dateString) => {
    setFormData(prev => ({
      ...prev,
      DateOfBirth: dateString ? moment(dateString).format('YYYY-MM-DD') : '0000-00-00'
    }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return; // Handle case where no file is selected

    // Convert the file to base64
    const base64 = await convertFileToBase64(file);

    // Validate base64 data (check for image/jpeg, image/png, or application/pdf)
    if (!isValidBase64(base64)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid File Type',
        text: 'Please select a valid file type (JPEG, PNG, PDF).',
      });
      return;
    }

    // If validation passed, set base64 data in formData.Photo
    setFormData(prev => ({
      ...prev,
      Photo: base64,
    }));
  };

  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

  const isValidBase64 = (base64String) => {
    // Check if base64String starts with 'data:image/jpeg', 'data:image/png', or 'data:application/pdf'
    return /^data:(image\/jpeg|image\/png|application\/pdf);base64,/.test(base64String);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const uppercaseValue = name === 'CKYCReferenceNumber' ? value.toUpperCase() : value;
    setFormData(prev => ({
      ...prev,
      [name]: uppercaseValue
    }));
  };

  return (
    <>
      <div className='container'>
        {/* <h5 className='policy-detail-title'>KYC Details</h5> */}
        <div className='row mt-4'>
          <div className='col-md-6 col-sm-12 policy-detail-input mt-2'>
            <label className='mb-2'>Date Of Birth  <span className='text-danger'>*</span></label>
            <DatePicker
              className=''
              defaultValue={formData.DateOfBirth ? dayjs(formData.DateOfBirth, 'YYYY-MM-DD') : null}
              style={{ width: '100%' }}
              onChange={handleDateChange}
            />
          </div>
          <div className='col-md-6 col-sm-12 policy-detail-input mt-2' autoSave='off'>
            <label className='mb-2'>Enter PAN Card Number <span className='text-danger'>*</span></label>
            <MDBInput
              autoComplete='off'
              name='CKYCReferenceNumber'
              value={formData.CKYCReferenceNumber}
              onChange={handleChange}
              label='Pan Number'
              id='name'
              type='text'
            />
          </div>
      
        </div>
      </div>
    </>
  );
};

export default CarKyc;
